/**
 * Created by m.igrachev on 6/19/2017.
 */
import Tooltip from "../../tooltip/Tooltip";
import Focusable from "../../focusable/Focusable";

const TooltipPreferredPosition = Tooltip.documentedProps.filter(item => {
    return item.name === "preferredPosition";
});
TooltipPreferredPosition[0].name = "preferredErrorTooltipDirection"; //Validatable is renaming this property!

const documentedProperties = [].concat(TooltipPreferredPosition, Focusable.documentedProps, [
    {
        name: "valid",
        type: "Boolean",
        defaultValue: "undefined",
        isRequired: "true",
        description: "If set to false will display the Component in its error state."
    },
    {
        name: "validationMethod",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A method to be called to validate the value on change and/or blur."
    },
    {
        name: "controlMessageProperties",
        type: "Object",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Properties to customize the control message appearance."
    },
    {
        name: "required",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will visualize the component as required (with *)."
    },
    {
        name: "failedValidations",
        type: "Object",
        defaultValue: "n/a",
        isRequired: "false",
        description: "An object representing the validations that have failed for the component."
    },
    {
        name: "showValidityIcon",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true will show indicator in the label area of the component when the validations have passed without errors."
    }
]);

export default documentedProperties;
